import * as Yup from 'yup'

export const validationSchema = Yup.object({
  glazing_templates: Yup.array().min(1),
})
